(() => {
  const key = 'qoolala-saved-v1';
  let saved = {};
  try { const value = JSON.parse(localStorage.getItem(key) || '{}'); if (value && typeof value === 'object' && !Array.isArray(value)) saved = value; } catch {}
  let timer;
  function measure(card, action) {
    if (card.dataset.qgKind !== 'external' || !card.dataset.discoveryHandle) return;
    document.dispatchEvent(new CustomEvent('qoolala:engagement', {detail: {
      action, category: card.dataset.category, item_id: card.dataset.discoveryHandle
    }}));
  }
  function feedback(message) {
    const status = document.querySelector('[data-qg-card-feedback]');
    if (!status) return;
    status.textContent = message;
    clearTimeout(timer);
    timer = setTimeout(() => { status.textContent = ''; }, 5000);
  }
  // qoolala-share-start
  function shareFind(title, url, trigger, onShare) {
    const dialog = document.createElement('dialog');
    dialog.className = 'qg-share-dialog';
    dialog.setAttribute('aria-label', `Share ${title}`);
    const heading = document.createElement('h2'); heading.textContent = `Share ${title}`;
    const help = document.createElement('p'); help.textContent = 'Copy this link or share it using your device.';
    const label = document.createElement('label'); label.textContent = 'Link to share';
    const input = document.createElement('input'); input.type = 'text'; input.readOnly = true; input.value = url;
    label.append(input);
    const actions = document.createElement('div'); actions.className = 'qg-share-actions';
    const status = document.createElement('p'); status.setAttribute('role', 'status');
    const copy = document.createElement('button'); copy.type = 'button'; copy.textContent = 'Copy link';
    copy.dataset.shareCopy = '';
    copy.addEventListener('click', async () => {
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(url);
        status.textContent = 'Link copied.'; onShare();
      } catch {
        status.textContent = 'Select the link and copy it using your browser or keyboard.';
        input.focus(); input.select();
      }
    });
    actions.append(copy);
    if (typeof navigator.share === 'function') {
      const native = document.createElement('button'); native.type = 'button';
      native.textContent = 'Share using your device'; native.dataset.shareNative = '';
      native.addEventListener('click', async () => {
        native.disabled = true;
        try { await navigator.share({title, url}); status.textContent = 'Shared.'; onShare(); }
        catch (error) { status.textContent = error.name === 'AbortError' ? 'Sharing cancelled. The link is still available.' : 'Use Copy link or select the link to share it.'; }
        finally { native.disabled = false; }
      });
      actions.append(native);
    }
    const close = document.createElement('button'); close.type = 'button'; close.textContent = 'Close';
    close.setAttribute('aria-label', 'Close sharing');
    const finish = () => { dialog.remove(); trigger.focus(); };
    const dismiss = () => { if (typeof dialog.close === 'function') dialog.close(); else finish(); };
    close.addEventListener('click', dismiss);
    dialog.addEventListener('close', finish);
    dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
    actions.append(close); dialog.append(heading, help, label, actions, status); document.body.append(dialog);
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    input.focus(); input.select();
  }
  // qoolala-share-end
  function refreshCards(scope = document) { scope.querySelectorAll('.qg-card').forEach(card => {
    const link = card.querySelector('h3 a');
    if (!link || card.querySelector('.qg-card-actions')) return;
    const url = new URL(link.href, location.href).href;
    const title = link.textContent.trim();
    const actions = document.createElement('div');
    actions.className = 'qg-card-actions';
    const save = document.createElement('button');
    save.type = 'button';
    function refresh() {
      const active = Object.hasOwn(saved, url);
      card.dataset.qgSaved = String(active);
      save.textContent = active ? 'Saved' : 'Save';
      save.setAttribute('aria-pressed', String(active));
      save.setAttribute('aria-label', `${active ? 'Unsave' : 'Save'} ${title}`);
    }
    refresh();
    save.addEventListener('click', () => {
      const next = {...saved};
      if (Object.hasOwn(next, url)) delete next[url];
      else next[url] = {title, url};
      try { localStorage.setItem(key, JSON.stringify(next)); }
      catch { feedback('Your browser could not save this find. Check its storage settings.'); return; }
      saved = next;
      refresh();
      measure(card, Object.hasOwn(saved, url) ? 'save' : 'unsave');
      card.closest('[data-qoolala-gallery]').dispatchEvent(new CustomEvent('qoolala:saved'));
      feedback(Object.hasOwn(saved, url) ? 'Saved on this device.' : 'Removed from your saved finds.');
    });
    const share = document.createElement('button');
    share.type = 'button'; share.textContent = 'Share';
    share.setAttribute('aria-label', `Share ${title}`);
    share.addEventListener('click', () => shareFind(title, url, share, () => measure(card, 'share')));
    actions.append(save, share);
    if (card.dataset.qgKind === 'shop') {
      if (card.dataset.variantId) {
        const add = document.createElement('button');
        add.type = 'button'; add.textContent = 'Add to bag';
        add.setAttribute('aria-label', `Add ${title} to bag`);
        add.addEventListener('click', async () => {
          add.disabled = true; add.textContent = 'Adding…';
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 20000);
          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}cart/add.js`, {method: 'POST', headers: {'Content-Type': 'application/json'}, signal: controller.signal, body: JSON.stringify({items: [{id: card.dataset.variantId, quantity: 1}]})});
            if (!response.ok) {
              feedback('We could not add this item. Open the product to check availability.');
              return;
            }
            feedback(`${title} added to your bag.`);
            // The add is confirmed. A failed optional count refresh must never
            // suggest retrying the mutation and accidentally adding it twice.
            try {
              const cartResponse = await fetch(`${root}cart.js`, {cache: 'no-store', signal: controller.signal});
              if (cartResponse.ok) {
                const cart = await cartResponse.json();
                if (Number.isSafeInteger(cart.item_count) && cart.item_count >= 0) {
                  document.querySelectorAll('.qg-bag').forEach(bag => { bag.textContent = `Bag (${cart.item_count})`; });
                }
              }
            } catch {}
          } catch { feedback('We could not confirm this add. Check your bag before adding the item again.'); }
          finally { clearTimeout(timeout); add.disabled = false; add.textContent = 'Add to bag'; }
        });
        actions.prepend(add);
      } else {
        const choose = document.createElement('a'); choose.href = url;
        choose.textContent = card.dataset.available === 'true' ? 'Choose options' : 'View product';
        actions.prepend(choose);
      }
    }
    card.append(actions);
  }); }
  window.QoolalaCardActions = {refresh: refreshCards};
  refreshCards();
  document.addEventListener('shopify:section:load', event => refreshCards(event.target));
})();
